import React, { useState, useEffect } from "react";
import useGlobalStore from "../stores/globalStore";
import useGetTotalPrice from "../hooks/useGetTotalPrice";
import ResetFormButton from "./ResetFormButton";

function Summary() {
  //Store
  const {
    selectedNetwork,
    selectedBroadband,
    selectedTvBasePackage,
    selectedTvPackages,
    selectedFlexChannels,
    selectedBroadbandEquipment,
    selectedTvEquipment,
    selectedSecurity,
    digiCardAmount,
    selectedShipping,
  } = useGlobalStore((state) => state);

  //Hooks
  const { getTotalPrice } = useGetTotalPrice();

  //State
  const [totalMonthlyPrice, setTotalMonthlyPrice] = useState(0);
  const [totalOneTimePrice, setTotalOneTimePrice] = useState(0);

  //sideEffect
  useEffect(() => {
    setTotalMonthlyPrice(
      (selectedBroadband.discount_price ?? selectedBroadband.price ?? 0) +
        getTotalPrice(selectedTvPackages) +
        (selectedTvBasePackage.discount_price ?? selectedTvBasePackage.price ?? 0) +
        (selectedSecurity.discount_price ?? selectedSecurity.price ?? 0) +
        digiCardAmount * 35
    );
  }, [selectedBroadband, selectedTvPackages, selectedSecurity, digiCardAmount, selectedTvBasePackage]);

  useEffect(() => {
    setTotalOneTimePrice(
      getTotalPrice(selectedBroadbandEquipment) +
        getTotalPrice(selectedTvEquipment) +
        (selectedTvEquipment[0].id != 5555555 || selectedBroadbandEquipment[0].id != 4444444
          ? selectedShipping.price
          : 0)
    );
  }, [selectedBroadbandEquipment, selectedTvEquipment, selectedShipping]);

  return (
    <div className="tel-pt-summary">
      <h3 className="tel-pt-summary__title">Sammanställning</h3>
      <ResetFormButton />

      <div className="tel-pt-summary__content">
        <div className="tel-pt-summary__network">
          {selectedNetwork && (
            <>
              <p className="tel-pt-summary__product-type">Fibernät</p>
              <p className="tel-pt-summary__product-name">{selectedNetwork.title.replace(/&#038;/g, "&")}</p>
            </>
          )}
        </div>

        {/* Broadband */}
        {selectedBroadband.id != 2222222 && (
          <div className="tel-pt-summary__broadband">
            <p className="tel-pt-summary__product-type">Bredband</p>
            <p className="tel-pt-summary__product">
              <span className="tel-pt-summary__product-name">{selectedBroadband.title.replace(/&#038;/g, "&")}</span>

              <div className="tel-pt-summary__price-container">
                <span className="tel-pt-summary__price">
                  {" "}
                  {selectedBroadband.discount_price ? selectedBroadband.discount_price : (selectedBroadband.price || selectedBroadband.monthly_price)}{" "}
                </span>
                <span className="tel-pt-summary__price-ending">kr/mån</span>
              </div>
            </p>
          </div>
        )} 
 
        {/* Broadband equipment */}
        {selectedBroadbandEquipment[0].id != 4444444 && (
          <div className="tel-pt-summary__broadband-equipment">
            <p className="tel-pt-summary__product-type">Bredband tillbehör</p>
            {selectedBroadbandEquipment.map((broadbandEquipment) => (
              <p className="tel-pt-summary__product" key={broadbandEquipment.id}>
                <span className="tel-pt-summary__product-name">{broadbandEquipment.title.replace(/&#038;/g, "&")}</span>

                <div className="tel-pt-summary__price-container">
                  <span className="tel-pt-summary__price">
                    {broadbandEquipment.discount_price ? broadbandEquipment.discount_price : broadbandEquipment.price}{" "}
                  </span>
                  <span className="tel-pt-summary__price-ending">kr</span>
                </div>
              </p>
            ))}
          </div>
        )}

        {/* TV packages */}
        {(selectedTvBasePackage.id != 1231231 || digiCardAmount > 0) && (
          <div className="tel-pt-summary__tv-packages">
            <p className="tel-pt-summary__product-type">Tv paket</p>
            {selectedTvBasePackage.id != 1231231 && (
              <p className="tel-pt-summary__product" key={selectedTvBasePackage.id}>
                <span className="tel-pt-summary__product-name">{selectedTvBasePackage.title.replace(/&#038;/g, "&")}</span>

                <div className="tel-pt-summary__price-container">
                  <span className="tel-pt-summary__price">
                    {" "}
                    {selectedTvBasePackage.discount_price
                      ? selectedTvBasePackage.discount_price
                      : selectedTvBasePackage.price}{" "}
                  </span>
                  <span className="tel-pt-summary__price-ending">kr/mån</span>
                </div>
              </p>
            )}

            <div className="tel-pt-summary__product">
              <span className="tel-pt-summary__product-name">Programkort x {digiCardAmount}</span>

              <div className="tel-pt-summary__price-container">
                <span className="tel-pt-summary__price">{digiCardAmount * 35}</span>
                <span className="tel-pt-summary__price-ending">kr/mån</span>
              </div>
            </div>
          </div>
        )}

        {/* TV packages */}
        {selectedTvPackages[0].id != 3333333 && (
          <div className="tel-pt-summary__tv-packages">
            <p className="tel-pt-summary__product-type">Tillvalspaket</p>
            {selectedTvPackages.map((tvPackage) => (
              <p className="tel-pt-summary__product" key={tvPackage.id}>
                <span className="tel-pt-summary__product-name">{tvPackage.title.replace(/&#038;/g, "&")}</span>

                <div className="tel-pt-summary__price-container">
                  <span className="tel-pt-summary__price">
                    {" "}
                    {tvPackage.discount_price ? tvPackage.discount_price : (tvPackage.price || tvPackage.monthly_price)}{" "}
                  </span>
                  <span className="tel-pt-summary__price-ending">kr/mån</span>
                </div>

                {tvPackage.title.includes("Flex") && (
                  <ul className="tel-pt-summary__flex-channels">
                    {selectedFlexChannels &&
                      selectedFlexChannels.map((channel) => <li key={channel.id}>{channel.title.replace(/&#038;/g, "&")}</li>)}
                  </ul>
                )}
              </p>
            ))}
          </div>
        )}

        {/* Tv equipment */}
        {selectedTvEquipment[0].id != 5555555 && (
          <div className="tel-pt-summary__tv-equipment">
            <p className="tel-pt-summary__product-type">Tv tillbehör</p>
            {selectedTvEquipment.map((tvEquipment) => (
              <p className="tel-pt-summary__product" key={tvEquipment.id}>
                <span className="tel-pt-summary__product-name">{tvEquipment.title.replace(/&#038;/g, "&")}</span>
                <div className="tel-pt-summary__price-container">
                  <span className="tel-pt-summary__price">
                    {tvEquipment.discount_price ? tvEquipment.discount_price : tvEquipment.price}{" "}
                  </span>
                  <span className="tel-pt-summary__price-ending">kr</span>
                </div>
              </p>
            ))}
          </div>
        )}

        {/* Security */}
        {selectedSecurity.id != 6666666 && (
          <div className="tel-pt-summary__security-equipment">
            <p className="tel-pt-summary__product-type">Övrigt</p>
            <p className="tel-pt-summary__product" key={selectedSecurity.id}>
              <span className="tel-pt-summary__product-name">{selectedSecurity.title.replace(/&#038;/g, "&")}</span>

              <div className="tel-pt-summary__price-container">
                <span className="tel-pt-summary__price">
                  {selectedSecurity.discount_price ? selectedSecurity.discount_price : selectedSecurity.price}{" "}
                </span>
                <span className="tel-pt-summary__price-ending">kr/mån</span>
              </div>
            </p>
          </div>
        )}

        {/* Shipping */}
        {(selectedTvEquipment[0].id != 5555555 || selectedBroadbandEquipment[0].id != 4444444) && (
          <div className="tel-pt-summary__shipping">
            <p className="tel-pt-summary__product-type">Frakt</p>
            <p className="tel-pt-summary__product">
              <span className="tel-pt-summary__product-name">{selectedShipping.title.replace(/&#038;/g, "&")}</span>

              <div className="tel-pt-summary__price-container">
                <span className="tel-pt-summary__price">{selectedShipping.price}</span>
                <span className="tel-pt-summary__price-ending">kr</span>
              </div>
            </p>
          </div>
        )}

        {/* Total */}
        <div className="tel-pt-summary__total">
          <p className="tel-pt-summary__product-type">Total</p>
          <p className="tel-pt-summary__product">
            <span className="tel-pt-summary__product-name">Månadskostnad</span>
            <div className="tel-pt-summary__price-container">
              <span className="tel-pt-summary__price">{totalMonthlyPrice} </span>
              <span className="tel-pt-summary__price-ending">kr/mån</span>
            </div>
          </p>

          <p className="tel-pt-summary__product">
            <span className="tel-pt-summary__product-name">Engångskostnad</span>
            <div className="tel-pt-summary__price-container">
              <span className="tel-pt-summary__price">{totalOneTimePrice} </span>
              <span className="tel-pt-summary__price-ending">kr</span>
            </div>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Summary;
